import classNames from 'classnames';
import React, { Children, isValidElement } from 'react';
import { useIsMobile } from "../../../../helper/hooks/useIsMobile.js";
import { DropdownOption } from "../dropdownOption/DropdownOption.js";
import styles from "./DropdownOptions.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DropdownOptions = ({
  activeIndex,
  onSelect,
  nullable,
  onNullableClick,
  small,
  className,
  children
}) => {
  const isMobileDevice = useIsMobile();
  const classes = classNames(styles.dropdownOptions, className);
  if (isMobileDevice) {
    const handleChange = e => {
      const activeIndex = Number.parseInt(e.target.value, 10);
      onSelect(activeIndex);
    };
    return /*#__PURE__*/_jsxs("select", {
      className: styles.select,
      value: activeIndex,
      onChange: handleChange,
      children: [(nullable || activeIndex === -1) && /*#__PURE__*/_jsx("option", {
        disabled: !nullable,
        value: -1,
        children: "-"
      }), Children.map(children, (child, index) => {
        return /*#__PURE__*/isValidElement(child) ? /*#__PURE__*/_jsx("option", {
          value: index,
          "data-testid": child.props['data-testid'],
          children: child.props.label
        }) : null;
      })]
    });
  }
  return /*#__PURE__*/_jsxs("ul", {
    className: classes,
    role: "listbox",
    tabIndex: -1,
    "aria-orientation": "vertical",
    children: [nullable && onNullableClick && /*#__PURE__*/_jsx(DropdownOption, {
      label: "-",
      onClick: onNullableClick,
      small: small
    }, "-"), children]
  });
};